export default typeof window !== 'undefined'
  ? {
      RAZZLE_PROJECT: window.env.RAZZLE_PROJECT,
      RAZZLE_GRAPHQL_URL: window.env.RAZZLE_GRAPHQL_URL,
      RAZZLE_GTAG_ID: window.env.RAZZLE_GTAG_ID,
    }
  : {
      RAZZLE_PROJECT: process.env.RAZZLE_PROJECT,
      RAZZLE_GRAPHQL_URL: process.env.RAZZLE_GRAPHQL_URL,
      RAZZLE_GTAG_ID: process.env.RAZZLE_GTAG_ID,
    };
